import React, { FC } from "react"
import { useTranslation } from "react-i18next"
import * as Styled from "./PersonDetail.styled"

type PersonDetailProps = {
    title: string,
    children?: React.ReactNode,
    onChangeClick?: () => void,
}

export const PersonDetail: FC<PersonDetailProps> = ({
    title,
    children,
    onChangeClick
}) => {
    const { t } = useTranslation();

    const handleChangeClick = (ev: React.SyntheticEvent) => {
        ev.preventDefault();
        onChangeClick?.();
    }

    return (
        <Styled.PersonDetailWrapperStack>
            <Styled.PersonDetailHeaderStack>
                <Styled.PersonDetailHeader>
                    {title}
                </Styled.PersonDetailHeader>
                {
                    onChangeClick && (
                        <Styled.PersonDetailChangeLink href="/" onClick={handleChangeClick}>
                            {t("global.change")}
                        </Styled.PersonDetailChangeLink>
                    )
                }
            </Styled.PersonDetailHeaderStack>
            <Styled.PersonDetailBodyBox>
                {children}
            </Styled.PersonDetailBodyBox>
        </Styled.PersonDetailWrapperStack>
    )
}